import React from 'react'
import { styled } from '@mui/material'
import { Typography as BaseTypography } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  align-items: baseline;
  display: flex;
  justify-content: ${props => props.justifyContent ?? 'flex-end'};
`

export const Span = styled('span')`
  bottom: 2px;
  position: relative;
`

export const Typography = styled(({ children, display, ...props }) => (
  <BaseTypography {...props}>{children}</BaseTypography>
))`
  color: ${({ color, theme }) => theme.palette.brand[color]};
  display: ${props => props.display};
`
